export default "__VITE_ASSET__0263f215__"